import {
  CONTACT_BATCH_GET_FAIL,
  CONTACT_BATCH_GET_REQUEST,
  CONTACT_BATCH_GET_SUCCESS,
} from "../Constant/StudyBatchConstant";

export const get_contact_batchReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case CONTACT_BATCH_GET_REQUEST: {
      return { loading: true };
    }

    case CONTACT_BATCH_GET_SUCCESS: {
      return { loading: false, batchDet: payload };
    }

    case CONTACT_BATCH_GET_FAIL: {
      return { loading: false, error: payload };
    }
    default:
      return state;
  }
};
